import moment from 'moment';
import { dateTimeFormat } from '@/ts/DefaultTableConfigs';

export default class UnitGroupingItem {
    public id: number;
    public name: string;
    public type: string;
    public updatedAt: string;
    public size: number;

    constructor(
        id: number,
        name: string,
        type: string,
        updatedAt: string,
        size: number,
    ) {
        this.id        = id;
        this.name      = name;
        this.type      = type;
        this.updatedAt = updatedAt !== null ? moment(updatedAt).local().format(dateTimeFormat) : '';
        this.size      = size;
    }
}
